import React from 'react';
import { ReactCookieProps } from 'react-cookie';
import ContactForm, {
  Props as ContactFormProps,
} from '~components/ContactForm';
import Modal, { Props as ModalProps } from '~components/Modal';

type Props = Omit<ContactFormProps, keyof ReactCookieProps> &
  Pick<ModalProps, 'show' | 'onClose'>;

const ModalContactForm = ({ show, onClose, ...contactFormProps }: Props) => (
  <Modal show={show} onClose={onClose}>
    <ContactForm {...contactFormProps} />
  </Modal>
);

export default ModalContactForm;
